<dl class="deal-bijtelling__dl">
    <dt i18n="@@deal.summary.label-fiscal-value">Fiscal value</dt>
    <dd>
        {{ fiscalValue | currency: 'EUR':'symbol-narrow':'1.0-0' }},-
        <ng-container i18n="@@configurator.general.in-vat-abbr">incl. VAT</ng-container>
    </dd>
</dl>
<h4 class="deal-bijtelling__heading" i18n="@@configurator.bijtelling.heading">Calculate bijtelling for this year</h4>
<dl class="deal-bijtelling__dl">
    <dt i18n="@@configurator.bijtelling.tax-bracket">Tax bracket</dt>
    <dd>
        <mat-form-field>
            <mat-select [formControl]="taxBracket">
                <mat-option [value]="1">36.93%</mat-option>
                <mat-option [value]="2">49.5%</mat-option>
            </mat-select>
        </mat-form-field>
    </dd>
    <dt i18n="@@configurator.bijtelling.own-contribution-per-month">Own contribution per month</dt>
    <dd>
        <mat-form-field>
            <mat-label></mat-label>
            <input [formControl]="ownContribution" autocomplete="off" matInput min="0" placeholder="0" type="number" />
        </mat-form-field>
    </dd>
    <dt i18n="@@configurator.bijtelling.net-bijtelling">Net bijtelling</dt>
    <dd>
        <div>
            € {{ bijtellingCurrentYearPerMonth }},-
            <span class="time-unit" i18n="@@configurator.general.per-month-abbr">p/m</span>
        </div>
        <div>
            € {{ bijtellingCurrentYearPerYear }},-
            <span class="time-unit" i18n="@@configurator.general.per-year-abbr">p/y</span>
        </div>
    </dd>
</dl>

<p class="deal-bijtelling__description" i18n="@@configurator.bijtelling.description">
    Valid five years after vehicle registration in 2023.
</p>
<!-- REMOVED FOR 2023, BECAUSE BIJTELLING FOR 2024 AND 2023 IS THE SAME -->
<!-- <h4 class="deal-bijtelling__heading" i18n="@@configurator.bijtelling.heading--nextyear"> -->
<!--     Bijtelling when the contract starts next year -->
<!-- </h4> -->
<!-- <dl class="deal-bijtelling__dl"> -->
<!--     <dt i18n="@@configurator.bijtelling.net-bijtelling">Net bijtelling</dt> -->
<!--     <dd> -->
<!--         € {{ bijtellingNextYearPerMonth }},- -->
<!--         <span class="time-unit" i18n="@@configurator.general.per-month-abbr">p/m</span><br /> -->
<!--         € {{ bijtellingNextYearPerYear }},- -->
<!--         <span class="time-unit" i18n="@@configurator.general.per-year-abbr">p/y</span> -->
<!--     </dd> -->
<!--     <dt i18n="@@configurator.bijtelling.additional-bijtelling">Additional bijtelling as opposed to 2021</dt> -->
<!--     <dd> -->
<!--         € {{ bijtellingSavingsPerMonth }},- -->
<!--         <span class="time-unit" i18n="@@configurator.general.per-month-extra-abbr">extra p/m</span> -->
<!--         <br /> -->
<!---->
<!--         € {{ bijtellingSavingsPerYear }},- -->
<!--         <span class="time-unit" i18n="@@configurator.general.per-year-extra-abbr">extra p/y</span> -->
<!--     </dd> -->
<!---->
<!--     <dt>&nbsp;</dt> -->
<!--     <dd> -->
<!--         € {{ bijtellingSavingsOverDuration }},- -->
<!--         <span i18n="@@configurator.general.over-duration-contract">extra over duration contract</span> -->
<!--     </dd> -->
<!---->
<!--     <dt>&nbsp;</dt> -->
<dd class="deal-bijtelling__disclaimer" i18n="@@configurator.bijtelling.disclaimer">
    *All amounts mentioned here with regard to the addition are indicative and no rights can be derived from them.
</dd>
<!-- </dl> -->
